import type { AsyncThunk, AsyncThunkPayloadCreator } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { ApiErrorBody } from "@shared-kernel/domain/errors/api-error";
import { ApiError } from "@shared-kernel/domain/errors/api-error";

export type ApiThunkConfig = { extra: Partial<Dependencies>; rejectValue: ApiErrorBody };
type ApiThunkApi = Parameters<AsyncThunkPayloadCreator<unknown, never, ApiThunkConfig>>[1];

// createAsyncThunk ne garde de l'erreur que name/message : le body d'erreur de l'API y serait perdu. Ici, une ApiError
// rejette avec son body (action.payload du rejected) ; toute autre erreur (session, réseau) est relancée telle quelle,
// pour que les listeners d'authentification la voient encore dans action.error.
// Tous les thunks de l'API passent par ici, sauf ceux de la session (voir les exceptions d'architecture/API_ACTIONS.md)
export const createApiThunk = <Returned, ThunkArg = void>(
  typePrefix: string,
  payloadCreator: (arg: ThunkArg, thunkApi: ApiThunkApi) => Promise<Returned>,
): AsyncThunk<Returned, ThunkArg, ApiThunkConfig> =>
  createAsyncThunk<Returned, ThunkArg, ApiThunkConfig>(typePrefix, async (arg, thunkApi) => {
    try {
      return await payloadCreator(arg, thunkApi);
    } catch (error) {
      if (error instanceof ApiError) return thunkApi.rejectWithValue(error.body);
      throw error;
    }
  });
